import styled from "@emotion/styled";
import { Flex, Text } from "styles/utility-components";

import Button from "components/ui/button/Button";
import Modal from "components/ui/modal/Modal";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  // The prompt's name, or the prompt itself when it has none
  label: string;
  onDelete: () => void;
};

export default function DeleteQuickPromptModal({ open, onOpenChange, label, onDelete }: Props) {
  return (
    <Modal open={open} onOpenChange={onOpenChange} showCloseButton={false}>
      <Content>
        <Text h3>Delete quick prompt?</Text>
        <Label bold>{label}</Label>
        <Text>This removes it for everyone in your team.</Text>
        <Flex gap={8} justifyContent="flex-end">
          <Button buttonType="secondary" onClick={() => onOpenChange(false)}>
            Keep prompt
          </Button>
          <Button
            buttonStyle="destructive"
            onClick={() => {
              onDelete();
              onOpenChange(false);
            }}
          >
            Delete
          </Button>
        </Flex>
      </Content>
    </Modal>
  );
}

const Content = styled(Flex)({
  width: 440,
  gap: 16,
  flexDirection: "column",
  padding: 16,
});

// A long prompt shows its first three lines
const Label = styled(Text)({
  display: "-webkit-box",
  WebkitLineClamp: 3,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
});
